import { ListingRequestCard, ListingRequestCardHighest } from 'app/components/listing-request-card';
import { ListingList } from 'app/components/listing-list';
import React from 'react';
import type { ProfileListingResults } from './shared';
import { ProfileListingEmpty } from './profile-listing-empty';

export function NeighbourRequests({
  isLargeUI,
  results,
  searchQuery,
  setSearchQuery,
}: {
  isLargeUI: boolean;
  results: ProfileListingResults;
  searchQuery: string;
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
}) {
  return (
    <ListingList
      filters={results.filters}
      data={results.listings}
      isLoading={results.isLoading}
      isFetchingNextPage={results.query.isFetchingNextPage}
      numListingsTotal={results.total}
      onRefresh={results.query.resetThenRefetch}
      refreshing={results.query.isRefetching}
      byPassFixedHeight
      scrollEnabled={false}
      searchQuery={searchQuery}
      onSearchQueryChange={setSearchQuery}
      card={isLargeUI ? ListingRequestCardHighest : ListingRequestCard}
      presentation={{ padding: 'page', requestBanner: 'hidden', searchBar: 'visible', user: 'hidden' }}
      ListEmptyComponent={<ProfileListingEmpty translationKey="place.noListingsRequest" />}
    />
  );
}
